<template>
    <div>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Preços por CM quadrado
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="justify-center align-center">
              
            </v-row>
  
            <v-row class="justify-center">
              <table>
                <tr style="font-weight:bold; background:grey;">
                  <th style="width:240px;">Tipo</th>
                  <th style="width:80px;">Valor/cm</th>
                </tr>
                <tr v-for="(item, i) in precos" :key="i" class="linha">
                  <td class="coluna1">{{ item.tipo }}</td>
                  <td class="coluna1"> 
                    <v-text-field
                      dense
                      hide-details
                      class="valor"
                      v-model="item.valor"
                    ></v-text-field>
                  </td>
                </tr>
              </table>
            </v-row>
  
            <v-row class="justify-center">
              <v-col cols="12">
                <v-row>
  
                </v-row>
                <v-row class="justify-center my-8">
                  <v-btn small class="secondary success--text mx-2" rounded @click="voltar()">voltar</v-btn>
                  <v-btn small color="warning" class="mx-2" rounded @click="reduzir()">reduzir</v-btn>
                <div style="width: 80px;">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    suffix="%"
                    v-model="perc"
                  ></v-text-field>
                </div>
                  <v-btn small color="warning" class="mx-2" rounded @click="aumentar()">aumentar</v-btn>
                  <v-btn small color="primary" class="mx-2" rounded @click="salvar()">salvar</v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
        {{ msg }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="alert = false">
            X
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </template>
  
  <script>
  export default {
    name: "precos-cm2",
    computed: {
    precosCm2() {
        return this.$store.getters.precosCm2;
      },
    },
    watch: {
    precosCm2(p) {
        if (p){
          this.voltar()
        }
      }
    },
    mounted() {
      this.precos = this.precosCm2
    },
    data() {
      return {
        precos: [],
        perc: 0,
        alert: false,
        msg: ""
      }
    },
    methods: {
      voltar() {
        this.precos = this.precosCm2
        this.perc = 0
      },
      aumentar() {
        if (parseFloat(this.perc) <= 0) {
          return;
        }
        const desc = 1 + parseFloat(this.perc / 100);
        this.alterar(desc);
      },
      reduzir() {
        if (parseFloat(this.perc) <= 0) {
          return;
        }
        const desc = 1 - parseFloat(this.perc / 100);
        this.alterar(desc);
      },
      alterar(desc) {
        const novo = [];
        for (let i = 0; i < this.precos.length; i++) {
          const el = this.precos[i];
          let pr = el.valor;
          if (pr.includes(",")) {
            pr = pr.replace(",", ".");
          }
          pr = parseFloat(pr) * desc;
          const item = {
            tipo: el.tipo,
            valor: String(this.setCasas(pr)),
          };
          novo.push(item);
        }
        this.precos = novo;
        this.perc = 0;
      },
      setCasas(pr) {
        let casas = String(pr).split('.')
          if (casas.length > 1 && casas[1].length > 4) {
            pr = parseFloat(pr).toFixed(4)
          }
          if (casas.length > 1 && parseInt(casas[1]) === 1) {
            pr = parseFloat(pr).toFixed(2)
          }
          if (casas.length === 1) {
            pr = parseFloat(pr).toFixed(2)
          }
          return pr
      },
      salvar() {
        const res = []
        const list = this.precos
        for (let i = 0; i < list.length; i++) {
          const el = list[i];
          const obj = { "tipo": el.tipo, "valor": el.valor}
          res.push(obj)
        }
        this.$store.dispatch("setPrecosCm2", res)
        this.showAlert()
      },
      showAlert() {
          this.msg = "Salvo com sucesso!!";
          this.alert = true;
        },
    },
  };
  </script>
  
  <style scoped>
    .coluna1 {
      text-align:center;
      border-bottom: solid 1px #000;
    }
    .linha:nth-child(even) {
      background-color: #f2f2f2;
    }
    .linha:nth-child(odd) {
      background-color: #ffffff;
    }
    .valor{
      padding-left: 10px;
    }
  </style>